<app-loader *ngIf="isDisabled"></app-loader>
<div>
    <div class="row m-0">
        <div class="col"></div>
        <div class="col-auto">
            <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="OpenUserList()">
                <i class="bi bi-ui-checks" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Add Tax':'Loading...'}}
            </button>
        </div>
    </div>
    <div class="card border-radius-0 mt-1 p-0">
        <div class="card-header">
            Tax Declaration - Proof of Investment
        </div>
        <div class="card-body p-1">
            <div class="mb-2">
                <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
                    <div class="row mx-1">
                        <div class="col-md-3">
                            <label>Financial Year</label>
                            <ng-select name="ESS_TaxFinancialYearID" [items]="FinancialYears" bindLabel="FinancialYear"
                                bindValue="ESS_TaxFinancialYearID" [(ngModel)]="Filter.ESS_TaxFinancialYearID"
                                placeholder="Financial Year" (change)="Clear()">
                            </ng-select>
                        </div>
                        <div class="col mt-4">
                            <div class="btn-group btn-group-toggle d-block">
                                <label class="form-check-label link-dark px-1" style="margin-left: 5%;" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=true name='autobillingsitewise'
                                        [(ngModel)]="Filter.TaxType" (change)="Clear()">
                                    Tax Declaration
                                </label>
                                <label class="form-check-label link-dark px-1" style="margin-left: 4%;" ngbButtonLabel>
                                    <input class="form-check-input" type="radio" [value]=false
                                        name='autobillingsitewise' [(ngModel)]="Filter.TaxType" (change)="Clear()">
                                    Proof Of Investment
                                </label>
                            </div>
                        </div>
                        <div class="col-md-auto align-content-center">
                            <button class="btn btn-primary" [disabled]="isDisabled"><i class="bi bi-cloud-download me-2"
                                    *ngIf="!isDisabled"></i>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                                    *ngIf="isDisabled"></span>
                                {{!isDisabled?'Apply':'Loading...'}}</button>
                        </div>
                    </div>
                </form>
            </div>
            <div>
                <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger"
                    class="customeDatatable table table-bordered">
                    <thead class="table-light">
                        <tr>
                            <th style="width: 5px;">#</th>
                            <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsDelete}">Delete</th>
                            <th style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">Edit</th>
                            <th style="width: 5px;">View</th>
                            <th>Employee</th>
                            <th>EmpType</th>
                            <th>Financial Year Start</th>
                            <th>Financial Year End</th>
                            <th style="width: 20px;">Regime</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let TableData of TaxDatas; let i = index">
                            <th scope="row" style="width: 5px;">{{i+1}}</th>
                            <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsDelete}">
                                <div class="text-center" *ngIf="(!Filter.TaxType || (Filter.TaxType && (TableData['ESS_EmpTaxInvestmentId'] == null || TableData['ESS_EmpTaxInvestmentId'] == 0)))">
                                    <i class="bi bi-trash deleteIcon" (click)="Delete(i)"></i>
                                </div>
                            </td>
                            <td style="width: 5px;" [ngClass]="{'colHide': !this.common.PageRight.IsEdit}">
                                <div class="text-center">
                                    <i *ngIf="Filter.TaxType"
                                        [routerLink]="['/incometax/incometax/add/d/r/' + TableData['ESS_EmpTaxDeclarationID']]"
                                        class="bi bi-pencil-square editIcon"></i>
                                    <i *ngIf="!Filter.TaxType"
                                        [routerLink]="['/incometax/incometax/add/e/r/' + TableData['ESS_EmpTaxInvestmentID']]"
                                        class="bi bi-pencil-square editIcon"></i>
                                </div>
                            </td>
                            <td style="width: 5px;">
                                <div class="text-center">
                                    <i *ngIf="Filter.TaxType"
                                        [routerLink]="['/incometax/incometax/detail/d/' + TableData['ESS_EmpTaxDeclarationID']]"
                                        class="bi bi-eye text-success"></i>
                                    <i *ngIf="!Filter.TaxType"
                                        [routerLink]="['/incometax/incometax/detail/e/' + TableData['ESS_EmpTaxInvestmentID']]"
                                        class="bi bi-eye text-success"></i>
                                </div>
                            </td>
                            <td>
                                <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                                    <div class="col-2">
                                        <img *ngIf="TableData['Photo'] != null && TableData['Photo'] != ''"
                                            mat-card-image class="userImage"
                                            [src]="common.PhotoLink(TableData['Photo'])" />
                                        <div *ngIf="TableData['Photo'] == null || TableData['Photo'] == ''"
                                            class="initial-image">
                                            <div class="image">
                                                {{common.getInitial(TableData['EmpName'])}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-9 userdetail">
                                        <span class="text-label">{{TableData['EmpName']}}</span><br />
                                        <span class="text-label-light">#{{TableData['EmpCode']}}</span><br />
                                        <span class="text-label-light">{{TableData['DesignationName']}}</span>
                                    </div>
                                </div>
                            </td>
                            <td>{{TableData['EmpType']}}</td>
                            <td>{{TableData['FinancialYearStart']}}</td>
                            <td>{{TableData['FinancialYearEnd']}}</td>
                            <td style="width: 20px;">{{TableData['IsNewRegime']?'New':'Old'}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col"></div>
                <div class="col-auto">
                    <button type="button" 
                    class="btn btn-primary mx-1" [disabled]="isDisabled"
                    (click)="ExcelDump()"><i *ngIf="!isDisabled" class="bi bi-download me-1"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</div>